import {
  CLEAR_ALERTS,
  CREATE_ALERT,
  REMOVE_ALERT
} from '../actions/alertActions'

export default function alerts(state = [], action) {
  switch (action.type) {
    case CLEAR_ALERTS:
      if (action.scope) {
        return state.filter(alert => alert.scope !== action.scope)
      }

      return []
    case CREATE_ALERT:
      return [...state, action.alert]
    case REMOVE_ALERT:
      const idx = state.indexOf(action.alert)
      return [...state.slice(0, idx), ...state.slice(idx + 1)]
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ../src/reducers/alerts.js